import {
    EXPORT_DOCTOR_PERFORMANCE_FAIL,
    EXPORT_DOCTOR_PERFORMANCE_SUCCESS,
    EXPORT_DOCTOR_SALES_FAIL,
    EXPORT_DOCTOR_SALES_SUCCESS,
    GET_DOCTOR_PAYMENT_REPORT_DETAILS_FAIL,
    GET_DOCTOR_PAYMENT_REPORT_DETAILS_SUCCESS,
    GET_DOCTOR_PERFORMANCE_FAIL,
    GET_DOCTOR_PERFORMANCE_SUCCESS,
    GET_DOCTOR_REPORT_DETAILS_FAIL,
    GET_DOCTOR_REPORT_DETAILS_SUCCESS,
    GET_PAY_COMMISSION_REPORT_FAIL,
    GET_PAY_COMMISSION_REPORT_SUCCESS,
    GET_SALES_PERFORMANCE_FAIL,
    GET_SALES_PERFORMANCE_SUCCESS,
    RESET_REPORT_ACTION_STATE,
    RESET_REPORT_STATE
} from "./actionTypes"

const INIT_STATE = {
    salesPerformanceReport: [],
    doctorPerformanceReport: [],
    doctorReportDetails: [],
    doctorPaymentReportDetails: [],
    payCommission: [],
    exportDoctorPerformance: [],
    exportDoctorSales: [],
    error: [],
}

const Report = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SALES_PERFORMANCE_SUCCESS:
            return {
                ...state,
                salesPerformanceReport: action.payload
            }
        case GET_SALES_PERFORMANCE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_DOCTOR_PERFORMANCE_SUCCESS:
            return {
                ...state,
                doctorPerformanceReport: action.payload
            }
        case GET_DOCTOR_PERFORMANCE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_DOCTOR_REPORT_DETAILS_SUCCESS:
            return {
                ...state,
                doctorReportDetails: action.payload
            }
        case GET_DOCTOR_REPORT_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_DOCTOR_PAYMENT_REPORT_DETAILS_SUCCESS:
            return {
                ...state,
                doctorPaymentReportDetails: action.payload
            }
        case GET_DOCTOR_PAYMENT_REPORT_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_PAY_COMMISSION_REPORT_SUCCESS:
            return {
                ...state,
                payCommission: action.payload
            }
        case GET_PAY_COMMISSION_REPORT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_DOCTOR_SALES_SUCCESS:
            return {
                ...state,
                exportDoctorSales: action.payload
            }
        case EXPORT_DOCTOR_SALES_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_DOCTOR_PERFORMANCE_SUCCESS:
            return {
                ...state,
                exportDoctorPerformance: action.payload
            }
        case EXPORT_DOCTOR_PERFORMANCE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_REPORT_STATE:
            return {
                ...state,
                salesPerformanceReport: [],
                doctorPerformanceReport: [],
                doctorReportDetails: [],
                doctorPaymentReportDetails: [],
                payCommission: [],
                exportDoctorPerformance: [],
                exportDoctorSales: [],
                error: [],
            }
        case RESET_REPORT_ACTION_STATE:
            return {
                ...state,
                payCommission: [],
                exportDoctorPerformance: [],
                exportDoctorSales: [],
                error: [],
            }
        default:
            return state
    }
}

export default Report
